import React, { PropsWithoutRef } from "react";

interface Props {
  width?: number;
  height?: number;
  className?: string;
}

// Monogram-only (//m) purple mark used on light backgrounds. Falls back to white in dark mode.
export function LogoPurpleMark(props: PropsWithoutRef<Props>) {
  const { className, ...rest } = props;
  return (
    <>
      <svg
        className={className ? `block dark:hidden ${className}` : "block dark:hidden"}
        viewBox="0 0 52 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        {/* m */}
        <path
          d="M42.2836 14.4302V22.8182C42.2836 23.6665 41.6026 24.3519 40.7912 24.3519C39.9798 24.3519 39.2987 23.6665 39.2987 22.8182V14.9865C39.2987 12.7991 38.0668 12.0501 36.6395 12.0501C35.3089 12.0501 34.077 12.8985 33.2991 14.3348V14.4322V22.8201C33.2991 23.6685 32.6181 24.3539 31.8402 24.3539C30.9973 24.3539 30.3162 23.6685 30.3162 22.8201V14.9885C30.3162 12.8011 29.0843 12.0521 27.6569 12.0521C26.3263 12.0521 25.0945 12.9342 24.3166 14.3686V22.8221C24.3166 23.6705 23.6671 24.3559 22.8241 24.3559C22.0128 24.3559 21.3317 23.6705 21.3317 22.8221V11.1064C21.3317 10.2581 22.0128 9.57268 22.8241 9.57268C23.6671 9.57268 24.3166 10.2581 24.3166 11.1064V11.4978C25.4202 10.0952 26.7804 9.31043 28.5651 9.31043C30.3162 9.31043 31.937 10.1588 32.7483 11.8236C34.0138 10.1588 35.5695 9.31043 37.4824 9.31043C40.0133 9.30646 42.2836 11.0031 42.2836 14.4302Z"
          fill="#8B5CF6"
        />
        {/* // */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.17134 30.8048C1.30953 30.8405 1.44575 30.8584 1.58197 30.8584C2.27886 30.8584 2.91849 30.3895 3.10604 29.6803L10.4757 2.00128C10.7007 1.15295 10.2012 0.280783 9.35827 0.054297C8.51529 -0.172189 7.64863 0.330451 7.42357 1.17878L0.0539542 28.8578C-0.171102 29.7061 0.328366 30.5783 1.17134 30.8048ZM8.59826 30.8048C8.73645 30.8405 8.87267 30.8584 9.00889 30.8584C9.70577 30.8584 10.3454 30.3895 10.533 29.6803L17.9026 2.00129C18.1276 1.15296 17.6282 0.280789 16.7852 0.0543031C15.9422 -0.172183 15.0755 0.330457 14.8505 1.17879L7.48087 28.8578C7.25582 29.7061 7.75528 30.5783 8.59826 30.8048Z"
          fill="#6366F1"
        />
      </svg>
      <svg
        className={className ? `hidden dark:block ${className}` : "hidden dark:block"}
        viewBox="0 0 52 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M42.2836 14.4302V22.8182C42.2836 23.6665 41.6026 24.3519 40.7912 24.3519C39.9798 24.3519 39.2987 23.6665 39.2987 22.8182V14.9865C39.2987 12.7991 38.0668 12.0501 36.6395 12.0501C35.3089 12.0501 34.077 12.8985 33.2991 14.3348V14.4322V22.8201C33.2991 23.6685 32.6181 24.3539 31.8402 24.3539C30.9973 24.3539 30.3162 23.6685 30.3162 22.8201V14.9885C30.3162 12.8011 29.0843 12.0521 27.6569 12.0521C26.3263 12.0521 25.0945 12.9342 24.3166 14.3686V22.8221C24.3166 23.6705 23.6671 24.3559 22.8241 24.3559C22.0128 24.3559 21.3317 23.6705 21.3317 22.8221V11.1064C21.3317 10.2581 22.0128 9.57268 22.8241 9.57268C23.6671 9.57268 24.3166 10.2581 24.3166 11.1064V11.4978C25.4202 10.0952 26.7804 9.31043 28.5651 9.31043C30.3162 9.31043 31.937 10.1588 32.7483 11.8236C34.0138 10.1588 35.5695 9.31043 37.4824 9.31043C40.0133 9.30646 42.2836 11.0031 42.2836 14.4302Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.17134 30.8048C1.30953 30.8405 1.44575 30.8584 1.58197 30.8584C2.27886 30.8584 2.91849 30.3895 3.10604 29.6803L10.4757 2.00128C10.7007 1.15295 10.2012 0.280783 9.35827 0.054297C8.51529 -0.172189 7.64863 0.330451 7.42357 1.17878L0.0539542 28.8578C-0.171102 29.7061 0.328366 30.5783 1.17134 30.8048ZM8.59826 30.8048C8.73645 30.8405 8.87267 30.8584 9.00889 30.8584C9.70577 30.8584 10.3454 30.3895 10.533 29.6803L17.9026 2.00129C18.1276 1.15296 17.6282 0.280789 16.7852 0.0543031C15.9422 -0.172183 15.0755 0.330457 14.8505 1.17879L7.48087 28.8578C7.25582 29.7061 7.75528 30.5783 8.59826 30.8048Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export default LogoPurpleMark;


